module.exports = __webpack_public_path__ + "546c7c3e43f840757c1ea24eb71838bc.svg";